"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberValue = exports.getValue = exports.getAnyFieldsValue = exports.getRequiredIntermediateFieldsValue = exports.getPostProcessedFieldsValue = exports.getValuationFieldsValue = exports.getEligibilityFieldsValue = exports.getConcentrationLimitFieldsValue = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const getConcentrationLimitFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    (0, common_1.finleyAssert)(concentrationLimitProperty ===
        'eligibleExposureLessConcentrationLimitKickouts', `${concentrationLimitProperty} !==
      'eligibleExposureLessConcentrationLimitKickouts'`);
    return propertyGroup[concentrationLimitProperty];
};
exports.getConcentrationLimitFieldsValue = getConcentrationLimitFieldsValue;
const getEligibilityFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    (0, common_1.finleyAssert)(concentrationLimitProperty === 'eligibleExposure' ||
        concentrationLimitProperty === 'eligibilityKickout' ||
        concentrationLimitProperty === 'isEligible', `${concentrationLimitProperty} is not one of [eligibleExposure, eligibilityKickout, isEligible]`);
    return propertyGroup[concentrationLimitProperty];
};
exports.getEligibilityFieldsValue = getEligibilityFieldsValue;
const getValuationFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    (0, common_1.finleyAssert)(concentrationLimitProperty === 'valuation' ||
        concentrationLimitProperty === 'valuationRate', `${concentrationLimitProperty} !== 'valuation' ||
      ${concentrationLimitProperty} !== 'valuationRate'`);
    return propertyGroup[concentrationLimitProperty];
};
exports.getValuationFieldsValue = getValuationFieldsValue;
const getPostProcessedFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    (0, common_1.finleyAssert)(concentrationLimitProperty === 'normalizedExposure', `${concentrationLimitProperty} === 'normalizedExposure'`);
    return propertyGroup[concentrationLimitProperty];
};
exports.getPostProcessedFieldsValue = getPostProcessedFieldsValue;
const getRequiredIntermediateFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    (0, common_1.finleyAssert)(concentrationLimitProperty === 'exposure', `${concentrationLimitProperty} === 'exposure'`);
    return propertyGroup[concentrationLimitProperty];
};
exports.getRequiredIntermediateFieldsValue = getRequiredIntermediateFieldsValue;
const getAnyFieldsValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const propertyGroup = fields[concentrationLimitPropertyGroup];
    const value = propertyGroup[concentrationLimitProperty];
    return value;
};
exports.getAnyFieldsValue = getAnyFieldsValue;
const getValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    // Seeing a weird issue after the upgrade to node 22, where the property group should match
    // a switch/case value but somehow falls through to the default. Adding some logging.
    if (concentrationLimitPropertyGroup !== 'loanProductId' &&
        concentrationLimitPropertyGroup !== 'concentrationLimitFields' &&
        concentrationLimitPropertyGroup !== 'eligibilityFields' &&
        concentrationLimitPropertyGroup !== 'valuationFields' &&
        concentrationLimitPropertyGroup !== 'postProcessedFields' &&
        concentrationLimitPropertyGroup !== 'requiredIntermediateFields' &&
        concentrationLimitPropertyGroup !== 'dynamicIntermediateFields' &&
        concentrationLimitPropertyGroup !== 'baseFields' &&
        concentrationLimitPropertyGroup !== 'assignmentFields' &&
        concentrationLimitPropertyGroup !== 'concentrationLimitWaivers') {
        const bytes = new TextEncoder()
            .encode(concentrationLimitPropertyGroup)
            .join(',');
        return (0, common_1.finleyAssertUnreachable)(concentrationLimitPropertyGroup, new common_1.error.FinleyError(`weird issue debugging inside if: Invalid field group: ${concentrationLimitPropertyGroup}`, {
            metadata: {
                logMeta: {
                    concentrationLimitPropertyGroup,
                    bytes,
                    type: typeof concentrationLimitPropertyGroup,
                    constructor: _.isObjectLike(concentrationLimitPropertyGroup)
                        ? concentrationLimitPropertyGroup.constructor?.name ??
                            'no constructor name'
                        : 'not object like',
                },
            },
        }));
    }
    switch (concentrationLimitPropertyGroup) {
        case 'loanProductId':
            return fields.loanProductId;
        case 'concentrationLimitFields':
            return (0, exports.getConcentrationLimitFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'eligibilityFields':
            return (0, exports.getEligibilityFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'valuationFields':
            return (0, exports.getValuationFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'postProcessedFields':
            return (0, exports.getPostProcessedFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'requiredIntermediateFields':
            return (0, exports.getRequiredIntermediateFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'dynamicIntermediateFields':
        case 'baseFields':
            return (0, exports.getAnyFieldsValue)({
                fields,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            });
        case 'assignmentFields':
        case 'concentrationLimitWaivers':
            return (0, common_1.finleyAssert)(false, `Invalid field group: ${concentrationLimitPropertyGroup}`);
        default: {
            // Seeing a weird issue after the upgrade to node 22, where the property group should match
            // a switch/case value but somehow falls through to the default. Adding some logging.
            const bytes = new TextEncoder()
                .encode(concentrationLimitPropertyGroup)
                .join(',');
            return (0, common_1.finleyAssertUnreachable)(concentrationLimitPropertyGroup, new common_1.error.FinleyError(`weird issue debugging inside switch: Invalid field group: ${concentrationLimitPropertyGroup}`, {
                metadata: {
                    logMeta: {
                        concentrationLimitPropertyGroup,
                        bytes,
                        type: typeof concentrationLimitPropertyGroup,
                        constructor: _.isObjectLike(concentrationLimitPropertyGroup)
                            ? concentrationLimitPropertyGroup.constructor
                                ?.name ?? 'no constructor name'
                            : 'not object like',
                    },
                },
            }));
        }
    }
};
exports.getValue = getValue;
const getNumberValue = ({ fields, concentrationLimitProperty, concentrationLimitPropertyGroup, }) => {
    const value = (0, exports.getValue)({
        fields,
        concentrationLimitProperty,
        concentrationLimitPropertyGroup,
    });
    (0, common_1.finleyAssert)(typeof value === 'number', new common_1.error.FinleyError(`expected value for [${concentrationLimitPropertyGroup}.${concentrationLimitProperty}] to be a number, but found: [${value}]`, {
        metadata: {
            logMeta: {
                value,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            },
        },
    }));
    return value;
};
exports.getNumberValue = getNumberValue;
//# sourceMappingURL=getValue.js.map